module.exports = __webpack_public_path__ + "index/img/BG.c2c2741.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/BG.png
// module id = 1s4E
// module chunks = 2